import { format } from 'date-fns';

// Constants
export const TENANT_STATES = {
  CURRENT: 'current',
  UPCOMING: 'upcoming',
  EXPIRED: 'expired',
} as const;

export const TAG_TONES = {
  [TENANT_STATES.CURRENT]: 'blue',
  [TENANT_STATES.UPCOMING]: 'purple',
  [TENANT_STATES.EXPIRED]: 'orange',
} as const;

export const DEFAULT_TAG_TONE = 'gray';

// Types
export type TenantState = (typeof TENANT_STATES)[keyof typeof TENANT_STATES];

// Utility functions
export const getTagTone = (state: string): 'blue' | 'purple' | 'orange' | 'gray' => {
  const normalizedState = state.toLowerCase() as TenantState;
  return (TAG_TONES[normalizedState] || DEFAULT_TAG_TONE) as 'blue' | 'purple' | 'orange' | 'gray';
};

export const getTenantState = (state: string) => {
  return `${state.charAt(0).toUpperCase() + state.slice(1).toLowerCase()} tenant`;
};

export const getValueOrDash = (value: string | number | undefined): string => {
  return value?.toString() || '-';
};

export const formatDate = (dateMs: number): string => {
  return format(new Date(dateMs), 'MMMM d, yyyy');
};
